<div v-if="results.length" class="store-results-page grid pagelist-grid grid-x grid-margin-x align-center">
    <article v-for="result in results" class="cell grid-item is-link small-12 medium-6 large-4 xlarge-3 margin-bottom-2"
        :key="result.id">
        <figure class="
                image-aspect-ratio
                three-by-two
            ">
            <img v-if="result.image && result.image.listImageURL" loading="lazy" :src="result.image.listImageURL"
                alt="" />
            <img v-else loading="lazy" src="../../../../images/no-image-3x2.png" alt="" />
        </figure>
        <div class="grid-caption">
            <h3 class="
                    h4
                    grid-title
                ">
                {{ result.title }}
            </h3>
            {{ result.content }}

            <div v-if="result.externalWebsite && result.externalWebsite.url || result.phoneNumber && result.phoneNumber.title || result.googleMapsLink && result.googleMapsLink.url"
                class="result-details margin-bottom-1">
                <div v-if="result.externalWebsite && result.externalWebsite.url">
                    <img class="info-icon" src="../../../../images/icon-link.svg" alt="Link icon">
                    <a :href=result.externalWebsite.url
                        :target="result.externalWebsite.openInNew ? '_blank' : '_self'">Visit Website</a>
                </div>
                <div v-if="result.phoneNumber && result.phoneNumber.title">
                    <img class="info-icon phone" src="../../../../images/icon-phone.svg" alt="Phone icon">
                    {{ result.phoneNumber.title }}
                </div>
                <div v-if="result.googleMapsLink && result.googleMapsLink.url">
                    <img class="info-icon" src="../../../../images/icon-pin.svg" alt="Pin icon">
                    <a :href=result.googleMapsLink.url
                        :target="result.googleMapsLink.openInNew ? '_blank' : '_self'">Get Directions</a>
                </div>
            </div>
            <span class="button secondary">
                View Details
            </span>
        </div>
        <a :href=result.link class="absolute-cover" v-if="result.link">
            <span class="show-for-sr">
                Read More About {{ result.title }}
            </span>
        </a>
    </article>
</div>
<div v-else-if="isLoading.loading" class="text-center margin-top-3 margin-bottom-3">
    <p>
        Loading...
    </p>
</div>
<div v-else class="text-center margin-top-3 margin-bottom-3">
    <p class="h4">Oops...</p>
    <p>No results found. Please try again.</p>
</div>
